import { render, staticRenderFns } from "./moduleLayout.vue?vue&type=template&id=1ab8b35c&"
import script from "./moduleLayout.vue?vue&type=script&lang=js&"
export * from "./moduleLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports